import { forwardRef } from "react";
import TeamExpensesReport from "./TeamExpensesReport";

/**
 * Products Expenses Report — same template as the Team Expenses Report but
 * driven by the "cogs" expense type, matching the Products tab on the
 * Performance Overview page.
 */
const ProductsExpensesReport = forwardRef(function ProductsExpensesReport(
  props,
  ref
) {
  return (
    <TeamExpensesReport
      {...props}
      ref={ref}
      expenseType="cogs"
      reportTitle={"Products Expenses\nOverview Report"}
    />
  );
});

export default ProductsExpensesReport;
